import { render, staticRenderFns } from "./ReportStatus.vue?vue&type=template&id=2c386dbb&scoped=true"
import script from "./ReportStatus.vue?vue&type=script&lang=js"
export * from "./ReportStatus.vue?vue&type=script&lang=js"
import style0 from "./ReportStatus.vue?vue&type=style&index=0&id=2c386dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c386dbb",
  null
  
)

export default component.exports